import api from '@pray/shared/utils/api';

export const retrySocialPost = async ({
  artistId,
  socialPostId,
  title = null,
  description = null,
  platforms = [],
  publishedAt = null,
}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!socialPostId) throw Error('Social Post ID is required');

  const params = {
    title,
    description,
    platforms,
    ...(publishedAt ? { published_at: publishedAt } : {}),
  };

  const url = `/web/studio/artists/${artistId}/social-posts/${socialPostId}`;
  await api.executePutRequest(url, params);
};
